import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  distance?: number;
};
export function Reveal({
  children,
  className = "",
  delay = 0,
  distance = 20
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div className={className} initial={reduceMotion ? false : {
    opacity: 0,
    y: distance
  }} whileInView={reduceMotion ? undefined : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-250" data-mp="3gfe4peqhsw5o">
      {children}
    </motion.div>;
}